import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopInfoKickMemberResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopKickMember = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.KickMember), switchMap(function (action) {
        var coopId = action.coopId, playerId = action.playerId, playerIdToKick = action.playerIdToKick;
        return deps
            .netSend({
            id: CommandCode.KickCoopMember,
            props: {
                coopId: coopId,
                playerId: playerId,
                playerIdToKick: playerIdToKick,
            },
        })
            .pipe(retry(), map(actionCoopInfoKickMemberResponse));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopKickMember.ts
// module id = 1811
// module chunks = 3